interface AnimatedGradientBackgroundProps {
  className?: string;
  variant?: "green" | "blue" | "gold" | "vibrant" | "subtle";
}

const AnimatedGradientBackground = ({ 
  className = "", 
  variant = "vibrant" 
}: AnimatedGradientBackgroundProps) => {
  const gradientVariants = {
    green: "from-eco-green/20 via-teal-bright/10 to-eco-green-light/20",
    blue: "from-sky-blue/20 via-purple/10 to-sky-blue-light/20",
    gold: "from-primary/20 via-amber-glow/10 to-gold-light/20",
    vibrant: "from-eco-green/15 via-teal-bright/10 to-sky-blue/15",
    subtle: "from-secondary/50 via-card/30 to-secondary/50",
  };

  return (
    <div 
      className={`absolute inset-0 bg-gradient-to-br ${gradientVariants[variant]} animate-gradient-shift bg-[length:200%_200%] ${className}`}
      style={{ backgroundSize: "200% 200%" }}
    />
  );
};

export default AnimatedGradientBackground;
